import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, ArrowRight } from 'lucide-react';
import type { Brand } from '../../types';

interface BrandCardProps {
  brand: Brand;
}

export default function BrandCard({ brand }: BrandCardProps) {
  return (
    <Link
      to={`/brands/${brand.id}`}
      className="group relative bg-white rounded-xl border border-gray-200 hover:border-blue-500 p-3 sm:p-4 md:p-6 transition-all duration-300 hover:shadow-lg flex flex-col"
    >
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 p-2 sm:p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors">
          <Wrench className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600" />
        </div>
        <div className="min-w-0 flex-1">
          <h4 className="text-sm sm:text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors truncate">
            {brand.name}
          </h4>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">
            All Appliance Services
          </p>
        </div>
      </div>
      
      <div className="absolute bottom-2 right-2 sm:bottom-3 sm:right-3 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
        <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
      </div>
    </Link>
  );
}